import React from 'react'
import { Breadcrumbs, Button } from "@material-ui/core";
import { PersonAdd, SearchSharp } from "@material-ui/icons";
import { MENU_HCE } from '../../../utils/constants';

const style = {
    root: {
      flexGrow: 1,
    },
  };

export const HceBreadcrumb = (props) => {

const { setActiveBreadcrumb, activeBreadcrumb } = props;

  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      <Button
        color={
          activeBreadcrumb === MENU_HCE.LISTADO_PACIENTES ? "default" : "inherit"
        }
        onClick={(e) => {
          setActiveBreadcrumb(MENU_HCE.LISTADO_PACIENTES);
        }}
      >
        <PersonAdd className={style.icon} />
        Listado de Pacientes
      </Button>

      {/* <Button
         color={
            activeBreadcrumb === MENU_HCE.REPORTES ? "default" : "inherit"
          }
        onClick={(e) => {
          setActiveBreadcrumb(MENU_HCE.REPORTES);
        }}
      >
        <SearchSharp className={style.icon} />
        Reportes
      </Button> */}

      <Button
        color={
          activeBreadcrumb === MENU_HCE.BUSQUEDA_POR_PACIENTE ? "default" : "inherit"
        }
        onClick={(e) => {
          setActiveBreadcrumb(MENU_HCE.BUSQUEDA_POR_PACIENTE);
        }}
      >
        <SearchSharp className={style.icon} />
        Buscar por paciente
      </Button>

    </Breadcrumbs>
  )
}
